import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=57e97062"
import script from "./left-menu.vue?vue&type=script&lang=js"
export * from "./left-menu.vue?vue&type=script&lang=js"
import style0 from "./left-menu.vue?vue&type=style&index=0&id=57e97062&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports